module.exports = __webpack_public_path__ + "static/img/logo.a023e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/logo.png
// module id = 2020
// module chunks = 62